import { render } from "./SlicesSlider.vue?vue&type=template&id=f5c64662&ts=true"
import script from "./SlicesSlider.vue?vue&type=script&lang=ts"
export * from "./SlicesSlider.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__